import {Token} from "@uniswap/sdk-core";
import {bsc, mainnet} from "./chains";

export const DEFAULT_CHAIN = mainnet;

export const SWAP_CONTRACTS = {
    [mainnet.id]: {
        v1Token: new Token(mainnet.id, '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', 6, 'USDC', 'USD Coin'),
        v2Token: new Token(mainnet.id, '0x878F41E82a8f2F4d71529A715c375A392b6040D6', 6, 'DWT', 'D-Wallet Token'),
        upgradeAddress: '0x51b4Ce59013CB7F879986Ed1A6993bF839c03812',
        walletAddress: '0xac1bB8495A58714Ac761072f9e17d953F59BA85d',
        swapRatio: 1,
        subgraphUrl: 'https://subgraph.d-wallet.net/mainnet/d-wallet-mainnet',
    },
    [bsc.id]: {
        v1Token: new Token(bsc.id, '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d', 18, 'USDC', 'USD Coin'),
        v2Token: new Token(bsc.id, '0x878F41E82a8f2F4d71529A715c375A392b6040D6', 18, 'DWT', 'D-Wallet Token'),
        upgradeAddress: '0x51b4Ce59013CB7F879986Ed1A6993bF839c03812',
        walletAddress: '0xac1bB8495A58714Ac761072f9e17d953F59BA85d',
        swapRatio: 1,
        subgraphUrl: 'https://subgraph.d-wallet.net/bsc/d-wallet-bsc',
    },
    // [holesky.id]: {
    //     v1Token: new Token(holesky.id, '0xd2cf6d71c745ba65b275df8ed1abcbfcb339973e', 6, 'USDC', 'USD Coin'),
    //     v2Token: new Token(holesky.id, '0x1C8dD3A6350F14AD503cd9870d10F2B0C5841019', 6, 'DWT', 'D-Wallet Token'),
    //     upgradeAddress: '0x173789D0Bf18A2586e9A52B7814e9e139602F9b9',
    //     walletAddress: '0x65621095Dc47215EB6b8133F27E5944A0dCbEb0b',
    //     swapRatio: 1,
    //     subgraphUrl: 'https://api.studio.thegraph.com/query/78345/dwt-upgrade-holesky/version/latest',
    // },
    // [avalancheFuji.id]: {
    //     v1Token: new Token(avalancheFuji.id, '0x59FBa7B175CC0D0b6F9e83B30511F440b2828D31', 6, 'USDC', 'USD Coin'),
    //     v2Token: new Token(avalancheFuji.id, '0xD2Cf6D71C745Ba65B275DF8ED1AbCbFCb339973e', 18, 'DWT', 'D-Wallet Token'),
    //     upgradeAddress: '0xd9ECC4C8E1EC850c6aD500343e28e037506a730E',
    //     walletAddress: '0x65621095Dc47215EB6b8133F27E5944A0dCbEb0b',
    //     swapRatio: 1,
    //     subgraphUrl: 'https://api.studio.thegraph.com/query/78345/dwt-upgrade-fuji/version/latest',
    // },
};
